import lineStyle from './funnel.labelLine.lineStyle'

export default {
  name: "labelLine",
  nickname: "引导线样式",
  desc:
    '标签的视觉引导线样式，在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-funnel.label.position">label 位置</a> 设置为<code class="codespan">&#39;left&#39;</code>或者<code class="codespan">&#39;right&#39;</code>的时候会显示视觉引导线。',
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示视觉引导线。",
    },
    length: {
      name: "length",
      nickname: "长度",
      desc: "视觉引导线的长度。",
    },
    lineStyle,
  },
}
